import Vue from "vue"
import Vuelidate from "vuelidate"
import VueFlatPickr from "vue-flatpickr-component"
import "flatpickr/dist/flatpickr.css"
import VueMeta from "vue-meta"
import Notifications from "vue-notification"
import VueGtm from "vue-gtm"
import VueTippy from "vue-tippy"
import VueAnalytics from "vue-analytics"

import App from "@/App.vue"
import router from "@/router"
import store from "@/store"
import filters from "@/utils/filters"
import "@/assets/scss/main.scss"
import errorLogger from "@/utils/errorLogger"
import Error500 from "@/views/errors/500"

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(VueFlatPickr)
Vue.use(Notifications)

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM, // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: process.env.VUE_APP_GTM_DEBUG, // Whether or not display console logs debugs (optional)
  vueRouter: router // Pass the router instance to automatically sync with router (optional)
})

// Tooltips - https://kabbouchi.github.io/vue-tippy/
Vue.use(VueTippy, {
  arrow: true,
  theme: "translucent",
  placement: "bottom"
})

// Route custom metadata
Vue.use(VueMeta, {
  keyName: "metaInfo", // the component option name that vue-meta looks for meta info on.
  attribute: "data-vue-meta", // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: "data-vue-meta-server-rendered", // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: "vmid" // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

/**
 * Globals
 */
// Analytics
if (process.env.VUE_APP_GA) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GA
  })
}
// Error handling
Vue.config.errorHandler = (error, vm, info) => {
  errorLogger.log(error, vm, info)
}
// Components
const globals = require.context("@/components/global", false, /.*\.vue$/)
globals.keys().forEach(fileName => {
  const config = globals(fileName)

  const name = fileName.replace(/^\.\/(.*)\.\w+$/, "$1")

  Vue.component(name, config.default || config)
})
// Filters
for (var filter in filters) {
  if (filters.hasOwnProperty(filter)) {
    Vue.filter(filter, filters[filter])
  }
}
// Debugging
if (process.env.NODE_ENV === "development") {
  // eslint-disable-next-line no-console
  Vue.prototype.$log = console.log
}

// Global Web3 Event bus
Vue.prototype.$web3 = new Vue()

const vueConfig = {
  router,
  store,
  render: h => {
    // const component = process.env.VUE_APP_MAINTENANCE ? Maintenance : App
    return h(App)
  }
}

if (process.env.VUE_APP_MAINTENANCE) {
  // Show maintenance page
} else {
  const asyncSetup = []

  if (window.web3 !== undefined) {
    asyncSetup.push(store.dispatch("fetchArtifacts"))
  }

  Promise.all(asyncSetup)
    .then(() => {
      store.dispatch("restoreSession")
      /* eslint-disable-next-line no-new */
      new Vue(vueConfig).$mount("#app") // 3a. Bootstrap application successfully
    })
    .catch(error => {
      errorLogger.log(error)
      vueConfig.render = h => h(Error500)
      /* eslint-disable-next-line no-new */
      new Vue(vueConfig).$mount("#app") // 3b. Bootstrap application with error
    })
}
